import { createContext, useContext } from "react";

export const BrandSetupReadOnlyContext = createContext(false);

export const useBrandSetupReadOnly = () =>
  useContext(BrandSetupReadOnlyContext);
